import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { School } from '../../../modules/SchoolManagement/types/school';
import { RequestStatus } from '../../../enums';
import school from '../../../apis/school';

interface SchoolState {
  schools: School[];
  singleSchool: School;
  schoolStatus?: RequestStatus;
  singleSchoolStatus?: RequestStatus;
}

const initialState: SchoolState = {
  schools: [],
  singleSchool: {
    id: '',
    shortCode: '',
    displayCode: ''
  }
};

const fetchSchools = createAsyncThunk(
  'school/get',
  async (_: void, { rejectWithValue, dispatch }) => {
    try {
      const schoolsData = await school.getSchools();
      return schoolsData;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const fetchSchoolByName = createAsyncThunk(
  'school/getByName',
  async (schoolName: string, { rejectWithValue, dispatch }) => {
    try {
      const singleSchool = await school.getSchoolByName(schoolName);
      return singleSchool;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const schoolSlice = createSlice({
  name: 'school',
  initialState,
  reducers: {
    clearSchoolState: () => initialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSchools.pending, (state) => {
        state.schoolStatus = RequestStatus.LOADING;
      })
      .addCase(fetchSchools.fulfilled, (state, action) => {
        state.schools = action.payload as unknown as School[];
        state.schoolStatus = RequestStatus.SUCCESS;
      })
      .addCase(fetchSchools.rejected, (state) => {
        state.schoolStatus = RequestStatus.FAILED;
      })
      // Add cases for fetchSchoolByName
      .addCase(fetchSchoolByName.pending, (state) => {
        state.schoolStatus = RequestStatus.LOADING;
      })
      .addCase(fetchSchoolByName.fulfilled, (state, action) => {
        state.singleSchool = action.payload as unknown as School;
        state.schoolStatus = RequestStatus.SUCCESS;
      })
      .addCase(fetchSchoolByName.rejected, (state) => {
        state.schoolStatus = RequestStatus.FAILED;
      });
  }
});

export const { clearSchoolState } = schoolSlice.actions;

export { fetchSchools, fetchSchoolByName };

export default schoolSlice;
